import { InputCapture, captureStore } from '@playcastdotio/InputCapture';
import { MobileGamepad } from '@playcastdotio/MobileGamepad';

export const MobileGamepadPage = () => {
  captureStore.updateAccess({
    mouse: false,
    keyboard: false,
    touch: true,
    gamepad: false,
  });

  return (
    <>
      <InputCapture />
      <MobileGamepad testMode={true} />
    </>
  );
};
